import React from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'

import * as selectors from './backgrounds.selectors'

/***/
class BackgroundsContainer extends React.Component {
  /**
   *  Render each background
   *  @param   {Object}  background  The background definition from storyline
   *                                 enhanced with particular scene
   *                                 configuration
   */
  renderBackground(background) {
    let backgroundStyle = { ...background.style }
    if (background.url) {
      backgroundStyle = {
        ...backgroundStyle,
        backgroundImage: `url(${background.url})`,
      }
    }

    return <div key={background.id} className="background-item" style={backgroundStyle} />
  }

  /***/
  render() {
    const { backgrounds } = this.props

    return (
      <div className="background-container">
        {backgrounds.map((background) => this.renderBackground(background))}
      </div>
    )
  }
}

const mapStateToProps = (state) => {
  return {
    backgrounds: selectors.getCurrentSceneBackgrounds(state),
  }
}

BackgroundsContainer.propTypes = {
  backgrounds: PropTypes.array,
}

export default connect(mapStateToProps)(BackgroundsContainer)
